import { Avatar } from '@mui/material';
import { FunctionComponent } from 'react';

export const CopilotAvatar: FunctionComponent = () => (
  <Avatar
    alt="Copilot"
    src="/images/copilot-logo.svg"
    className="m-auto w-[60px] h-[60px]"
  />
);
